import { Step } from "../types/Step";

export const stepTitles = {
  [Step.COSA]: "Scegli COSA vuoi assicurare",
  [Step.SCONTO]: "Personalizza la tua polizza",
};

export const stepSubTitles = {
  [Step.COSA]: "",
  [Step.SCONTO]: "",
};
